export class QualityResult {
  constructor({
        id= null, 
        resultCode= ``,
        parameterCode = '',
        parameterName=``, 
        parameterUnit=``,
        sampleCode= ``, 
        sampleName= ``,
        itemCode='',
        checkTime='',
        upValue= ``,
        downValue= ``,
        checkValue='',
        checkPerson='',
        status='',
        qualityResult='',
        furnaceName=''
    } = {}) {
    this.id = id;
    this.resultCode = resultCode;
    this.parameterName =parameterName;
    this.parameterCode = parameterCode;
    this.parameterUnit=parameterUnit;
    this.sampleName = sampleName;
    this.sampleCode = sampleCode;
    this.itemCode=itemCode;
    this.checkPerson=checkPerson;
    this.checkTime=checkTime;
    this.upValue=upValue;
    this.downValue=downValue;
    this.checkValue=checkValue;
    this.status=status;
    this.qualityResult=qualityResult;
    this.furnaceName=furnaceName;
  }
}
export function gridFields() {
  return Object.freeze(
      [
      
      
      {
        key: 'resultCode',
        label: 'lbl.qualityResult.resultCode',
        sortable: true,
        notInTable:true,
        form: {
          type: 'input'
        }
      },  
      {
        key: 'sampleName',
        label: 'lbl.qualityResult.sampleName',
        sortable: true,
        notInTable:true,
        form: {
          type: 'input'
        }
      },  
      {
        key: 'sampleCode',
        label: 'lbl.qualityResult.sampleCode',
        sortable: true,
        notInTable:true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'parameterName',
        label: 'lbl.qualityResult.parameterName',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'parameterCode',
        label: 'lbl.qualityResult.parameterCode',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'upValue',
        label: 'lbl.qualityResult.upValue',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'downValue',
        label: 'lbl.qualityResult.downValue',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'checkValue',
        label: 'lbl.qualityResult.checkValue',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'parameterUnit',
        label: 'lbl.qualityResult.parameterUnit',
        sortable: true,
        form: {
          type: 'input'
        }
      }, 
      {
        key: 'checkPerson',
        label: 'lbl.qualityResult.checkPerson',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'checkTime',
        label: 'lbl.qualityResult.checkTime',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'qualityResult',
        label: 'lbl.qualityResult.qualityResult',
        sortable: true,
        form: {
          type: 'select',
            options: [    
                { value: null, text:  ''  },            
                { value: 'L', text:  '低于范围值' },  
                { value: 'G', text:  '高出范围值' }, 
                { value: 'N', text:  '正常' },                   
              ]     
        }
      },
      {
        key: 'status',
        label: 'lbl.qualityResult.status',
        sortable: true,
        form: {
          type: 'select',
            options: [    
                { value: null, text:  ''  },            
                { value: 'N', text:  'lbl.qualityResult.status.N' },  
                { value: 'C', text:  'lbl.qualityResult.status.C' }, 
                                 
              ]     
        }
      }          
     
  ]);
}
export const fields = Object.freeze(Object.keys(new QualityResult()).map(i => 'entity.' + i));
export const filterFields = [
  
];
export const filter = {

  
};